import { Component, OnInit, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { InventoryItemQandA, DateUtilsService, DetailsState} from 'remarketing-angular-library';
import { AsyncPipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'lib-seller-update',
    templateUrl: './seller-update.component.html',
    styleUrls: ['./seller-update.component.scss'],
    imports: [TranslocoDirective, AsyncPipe]
})
export class SellerUpdateComponent implements OnInit {
  @Select(DetailsState.questions) questions$: Observable<InventoryItemQandA>;
  @Input() showHeading = true;

  constructor (
    private readonly dateUtilsService: DateUtilsService
  ) {}

  ngOnInit() {
  }

  localizeDate(date) {
    return this.dateUtilsService.localizeDate(date);
  }
}
